// @flow
import styled from 'styled-components';

export const TransactionPlayersWrapper = styled.div`
	display: flex;
	align-items: center;
	padding: 20px;
	justify-content: space-between;
`;
export default TransactionPlayersWrapper;


// WEBPACK FOOTER //
// ./src/components/Trades/TransactionPlayersWrapper.js